const ChanceAndSequenceImages = [
  {
    src: require("../assets/chance-and-seq/1-EBBEC538-1428-464C-B86D-FD1598FEBF86.jpg"),
  },
  {
    src: require("../assets/chance-and-seq/2-868F479E-15FE-4773-9A2F-17350B2CB0C6.jpg"),
  },
  {
    src: require("../assets/chance-and-seq/3-1F147D34-7D67-4ECC-8B5F-480426D39508.jpg"),
  },
  {
    src: require("../assets/chance-and-seq/4-7F0B7FFD-FBF3-40A5-AB95-0253A16BF22C.jpg"),
  },
  {
    src: require("../assets/chance-and-seq/5-F466C320-FE97-4211-B946-F51DB5CBB89C.jpg"),
  },
  {
    src: require("../assets/chance-and-seq/6-95B1CCD1-298F-4674-8FBD-006E756459BE.jpg"),
  },
  {
    src: require("../assets/chance-and-seq/7-B41EF05F-F51D-4A73-B254-FD858B39AF43.jpg"),
  },
  {
    src: require("../assets/chance-and-seq/8-9BFFE8AB-7E44-4F30-A4FD-68674CB24E50.jpg"),
  },
  {
    src: require("../assets/chance-and-seq/9-E3FCB9CF-EE4A-4DF5-871B-54EC88658DAC.jpg"),
  },
  {
    src: require("../assets/chance-and-seq/10-9943AC80-0C47-4DE2-8DE1-DBBB279D140A.jpg"),
  },
  {
    src: require("../assets/chance-and-seq/11-8900EF2E-C7BD-4895-AA6C-DD67871F6EB0.jpg"),
  },
  {
    src: require("../assets/chance-and-seq/12-E9D070A1-6FB7-4A5E-8EC0-BF3AE4B58530.jpg"),
  },
  {
    src: require("../assets/chance-and-seq/13-35FCDA84-297C-4F40-A71E-A63301E4068F.jpg"),
  },
  {
    src: require("../assets/chance-and-seq/14-BCFC11B8-4761-4C1D-8918-839FAECE59ED.jpg"),
  },
  {
    src: require("../assets/chance-and-seq/15-BDF4E89F-1591-4D2F-AB37-83E2CE9E2A9A.jpg"),
  },
  {
    src: require("../assets/chance-and-seq/16-74AAB172-5205-4869-89AE-B968B4FFA9F3.jpg"),
  },
  {
    src: require("../assets/chance-and-seq/17-CFAEFC65-026F-4FC1-966C-F6655606E6E3.jpg"),
  },
  {
    src: require("../assets/chance-and-seq/18-D01C3881-EB84-4390-9E26-F7300B64DE3B.jpg"),
  },
  {
    src: require("../assets/chance-and-seq/19-03F1F4FB-1928-45FF-BA04-ED3357598BBD.jpg"),
  },
  {
    src: require("../assets/chance-and-seq/20-3261075F-8010-4552-A93C-5BDC6A50DE2A.jpg"),
  },
];

export default ChanceAndSequenceImages;
